<style>
  .joinBox{
    position: absolute;
    width:100%;
    left:0;
    top:60px;
    margin:auto;
    bottom: 0;
    min-height: 400px;
  }
  .bg{
    height:100%;
    width:100%;
    position: absolute;
    left:0;
    top:0;
  }
  .joinContainer{
    height:192px;
    width:100%;
    position: absolute;
    top:0;
    bottom: 0;
    text-align: center;
    margin:auto;
  }
  .joinContainer p:nth-child(1){
    height:48px;
    font-size:34px;
    font-family:PingFang SC;
    font-weight:bold;
    line-height:48px;
    color:rgba(51,51,51,1);
  }
  .joinContainer p:nth-child(2){
    margin-top:20px;
     height:28px;
     font-size:20px;
     font-family:PingFang SC;
     font-weight:400;
     line-height:22px;
     color:rgba(81,71,231,1);
  }
  .buyBtn{
    width:150px;
    height:50px;
    margin-top:10px;
    background:rgba(81,71,230,1);
    opacity:1;
    border-radius:30px;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    line-height:50px;
    text-align: center;
    color:rgba(255,255,255,1);
    display: inline-block;
    cursor: pointer;
  }
  .moreBtn{
    margin-top:15px;
    height:21px;
    font-size:15px;
    font-family:PingFang SC;
    font-weight:400;
    line-height:21px;
    color:rgba(81,71,231,1);
    cursor: pointer;
  }
@media screen and (max-width:500px ) {
  .joinBox{
    top:40px;
  }
}
</style>

<template>
	<div class='joinBox'>
    <img class='bg' src="../assets/joinus.png" alt="">
    <div class='joinContainer'>
      <p>柜柜APP工厂版用户，才可以入驻</p>
      <p>RMB 6980起</p>
      <div @click='gotoBuy' class='buyBtn'>购买柜柜</div>
      <p @click='learnMore' class='moreBtn'>进一步了解 ></p>
    </div>
  </div>
</template>

<script>
	export default {
		components:{

		},
		props:[],
		data() {
			return {

			}
		},
		computed: {

		},
		mounted() {

		},
		methods: {
      gotoBuy(){
        window.open('http://eggrj.com/product.html')
      },
      learnMore(){
        window.open('http://eggrj.com/about-us.html')
      }
		}
	}
</script>
